import React from 'react';

import { Section, Layout, SEO, NewsletterSection, BrowseGamesSection, BrowseWebGamesSection } from '..';
import { LoveBoxSection } from "../LoveBoxSection";

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

import style from './HomePage.module.less';

import hero from './assets/hero.jpg';

export const HomePage = () => (
  <Layout transparentTop={true}>
    <SEO />

    <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
      <div className={style.wrapper}>
        <h1>Communicate <span>·</span> Solve <span>·</span> Escape</h1>
        <p>
          Cooperative puzzle games,
          <br />
          where communication is key
        </p>
        <button
          className={style.learnMore}
          type="button"
          onClick={() => {
            // eslint-disable-next-line no-unused-expressions
            document.querySelector('#ourGames')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Browse games
        </button>
      </div>
    </Section>

    <BrowseGamesSection />
    <BrowseWebGamesSection />

    <LoveBoxSection alternate={false} />
    <NewsletterSection tags={['home']} />
  </Layout>
);
